import React from "react";
import DataTable from "react-data-table-component";
import { useLocation } from "react-router-dom";

const ViewUsersForStaff = () => {
  const location = useLocation();
  const { data } = location?.state || {};

  const columns = [
    {
      name: "SL. No",
      selector: (row, index) => index + 1,
    },
    {
      name: "Customer No",
      selector: (row) => row?.UserData?.customerNo,
      sortable: true,
    },
    {
      name: "Name",
      selector: (row) => row?.UserData?.name,
      sortable: true,
    },
    {
      name: "Email",
      selector: (row) => row?.UserData?.email,
      sortable: true,
    },
  ];
  return (
    <>
      <div className="d-flex justify-content-end mt-5">
        <div className="form-header">
          <div>
            <div>
              <section className="piechartsBox_area">
                <div>
                  <div className="dateListDiv">
                    <h1
                      style={{
                        color: "#ff9c00",
                        fontSize: "25px",
                        fontWeight: "600",
                        marginBottom: "10px",
                      }}
                    >
                      Users of {data?.name}
                    </h1>
                  </div>
                </div>
                {/* <div>
                    <input
                      placeholder="Filter with Name, Phone No. & Email"
                      type="text"
                      value={filterText}
                      onChange={(e) => {
                        setFilterText(e.target.value);
                      }}
                      style={{
                        width: "20rem",
                        height: "30px",
                        backgroundColor: "#f5c778",
                        border: "none",
                        borderRadius: "8px",
                        padding: "0 10px",
                      }}
                    />
                  </div> */}

                <hr />
                <DataTable
                  columns={columns}
                  data={data?.AssignedUsers}
                  // data={filterText ? filteredStaffs : staffs}
                  // progressPending={fetchAllStaffLoading}
                  pagination
                />
              </section>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewUsersForStaff;
